import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { ListParamsType } from "../../../../../../list/services/types";
import { ListConfigAction } from "../../../services/types";

interface SingleActionButtonsProps {
	action: ListConfigAction;
	item: any;
	params?: ListParamsType;
	fetchData?: (params: ListParamsType) => Promise<any>;
}

export const SingleActionButton = ({
	action,
	item,
	params,
	fetchData,
}: SingleActionButtonsProps): JSX.Element | null => {
	const { addFlash } = useFlash();

	if (action.link) {
		const linkTo = action.link(item) || location.pathname;
		return (
			<Link to={linkTo} className="btn btn-light">
				{action.name}
			</Link>
		);
	}

	if (action.click) {
		const onClick = async () => {
			try {
				await action.click?.(item, params);
				if (action.refreshListAfter && fetchData) {
					await fetchData(params ?? { search: "" });
				}
			} catch (err) {
				if (action.customErrorHandler) {
					action.customErrorHandler(err, item);
				} else {
					handleError.alert(err, addFlash);
				}
			}
		};

		return (
			<Button variant="light" onClick={onClick}>
				{action.name}
			</Button>
		);
	}

	return null;
};
